import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { ButtonLink, SubmitButton } from "@/components/Interface/Button/Button";
import { CardModule } from "@/components/Layout/BaseLayouts/CardModule/CardModule";
import { OrSeparator } from "@/components/Layout/OrSeparator";
import { AuthenticatorSetupMethodsForm } from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/AuthenticatorSetupForm";
import { TwoFactorAlternatives } from "@/components/Portal/UserAccount/Security/Change/TwoFactorAlternatives";
import { TwoFactorQRCodeSection } from "@/components/Portal/UserAccount/Security/Change/TwoFactorQrCodeSection";
import { switch2faRouteByMethod } from "@/components/Portal/UserAccount/Security/utils";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

export const TwoFactorChangeAppView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { handleSubmit, watch, setValue } =
    useForm<AuthenticatorSetupMethodsForm>();

  const watchType = watch("type");

  const onSubmit = (data: AuthenticatorSetupMethodsForm) => {
    if (data.type) {
      navigate(switch2faRouteByMethod[data.type]);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CardModule
        stickyHeader
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <ButtonLink
              variant="secondary"
              size="sm"
              to={portalRoutes.user.security.base}
            >
              {t("portal:user-account.security.buttons.back")}
            </ButtonLink>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("Common.label.continue")}
              disabled={!watchType}
            />
          </>
        }
      >
        <TwoFactorQRCodeSection />
        <OrSeparator />
        <TwoFactorAlternatives
          currentMethod={ChangeTwoFactorAuthenticationMethod.APP}
          value={watchType ?? null}
          onChange={(type) => setValue("type", type)}
        />
      </CardModule>
    </form>
  );
};
